import {RecordForm} from '../forms/RecordForm';


import {useAccount} from '../hooks/useAccount';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        createRecord,
    } = useAccount();

    return (
        <FormPageLayout
            title='Add Account'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm handleSubmit={createRecord}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
